import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Drawer,
  Grid,
  Paper,
  Stack,
  Tab,
  Tooltip,
  Avatar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import Pagination from "@mui/material/Pagination";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getChildEntitiesList,
  getManagerInviteList,
  setBranchEntitiesLimit,
  setBranchEntitiesOffset,
  setBranchEntitiesPage,
} from "../../redux/features/authSlice";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddressForm from "../../sections/auth/UserProfile/addressForm";
import ContactForm from "../../sections/auth/UserProfile/contactForm";
import styled from "@emotion/styled";
import { RegistrationStatus } from "../../common/enum";
import {
  setConfirmationDialog,
  setDrawerState,
  setHeaderTitle,
  setRejectPayload,
} from "../../Containers/AdminView/adminSlice";
import ConfirmDialog from "../ConfirmDialog";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { updateRegistrationDetail } from "../../Containers/OnBoarding/slice";
import { enqueueSnackbar } from "notistack";
import ManageManagers from "../../Containers/DashBoardView/ManageManagers";
import ProfileAndBanner from "../../Containers/Donations/DonationDrawer/ProfileAndBanner";
import SvgIconStyle from "../../components/SvgIconStyle";
import { avataStyles, svgIconStyle } from "../../Containers/DonationView/Cart/styles";

const ViewEstablishmentDetails = ({
  id,
  establishmentEntityId,
  establishmentDetails,
  addressData,
  contactData,
  value,
  setValue,
  t,
  setDrawerState,
}) => {
  const dispatch = useDispatch();
  const [address, setAddressDetails] = useState(addressData);
  const [contact, setContactDetails] = useState(contactData);
  // let address = addressData;
  // let contact = contactData;

  const {
    auth: {
      profile: { entity, status },
      managerInviteOffset,
      managerInviteLimit,
      branchEntitiesOffset,
      branchEntitiesLimit,
    },
  } = useSelector((state) => state);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    display: "flex",
    width: "100%",
    padding: "10px",
    position: "relative",
    alignContent: "center",
    justifyContent: "space-between",
  }));

function toLocalISOString(inputDate) {
  const date = inputDate instanceof Date ? inputDate : new Date(inputDate);

  if (isNaN(date)) {
    throw new Error('Invalid date');
  }

  const offsetMs = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() - offsetMs);
  return adjustedDate.toISOString().slice(0, -1);
}
  
  const handleTabChange = (event, value) => {
    if (value === "users") {
      const data = {
        limit: managerInviteLimit,
        offset: managerInviteOffset,
        id: establishmentEntityId,
      };
     // dispatch(getManagerInviteList(data));
    }
    setValue(value);
  };

  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      userId: id,
      status:
        establishmentDetails.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    if (establishmentDetails.status === RegistrationStatus.active) {
      dispatch(setHeaderTitle(t("confirmationDeactivateContent")));
      dispatch(setRejectPayload(payload));
      dispatch(setConfirmationDialog(true));
    } else {
      dispatch(updateRegistrationDetail(payload))
        .unwrap()
        .then((res) => {
          const data = {
            entityId: entity?.entityId,
            offset: branchEntitiesOffset,
            limit: branchEntitiesLimit,
          };
          dispatch(getChildEntitiesList(data));
          enqueueSnackbar({
            message: t("successfullyEstablishmentoActivated"),
            variant: "success",
          });
          setDrawerState();
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("somethingWentWrong"),
            variant: "error",
          });
        });
    }
  }, [dispatch]);

  const refreshDetails = () => {
    const data = {
      entityId: entity?.entityId,
      offset: branchEntitiesOffset,
      limit: branchEntitiesLimit,
    };
    dispatch(getChildEntitiesList(data))
      .unwrap()
      .then((response) => {
        if (response?.obj?.entityDetailsLists?.length) {
          const filterDetails = response.obj.entityDetailsLists;
          const details = filterDetails.filter((data) => {
            return data?.entity?.id === establishmentEntityId;
          })[0];
          const filterAddress =
            details?.addresses?.filter((address) => {
              return addressData.addressId === address.addressId;
            })[0] || addressData;
          const filterContact =
            details?.contact?.filter((contact) => {
              return contactData.contactId === contact.contactId;
            })[0] || contactData;
          setAddressDetails(filterAddress);
          setContactDetails(filterContact);
        }
      });
  };
  return (
    <Box
      sx={{
        padding: 2,
        mt: 6,
      }}
    >
      <Typography variant="h5" color="text.secondary" gutterBottom>
        {address.addressTitle}
      </Typography>
      <Typography fontWeight="bold" variant="body1" mb={0.5}>
        {address.email}
      </Typography>
      <Typography variant="h5" color="text.secondary" component="div">
        {contact.name} ({contact.designation})
      </Typography>
      <Typography pt={0.5} fontWeight="bold" variant="body1" mb={1}>
        {contact.email}
      </Typography>
      <Box
        sx={{
          width: 1,
          backgroundColor:
            establishmentDetails.status === RegistrationStatus.active
              ? "#e5f1ff"
              : "#FFE2E2",
          display: "flex",
          alignItems: "center",
          borderRadius: 1.5,
          p: 1.5,
          my: 2,
        }}
      >
        <InfoIcon
          sx={{
            color:
              establishmentDetails.status === RegistrationStatus.active
                ? "#0167d6"
                : "#DC2600",
          }}
        />
        <Typography variant="body2" fontWeight={500} mx={2}>
          {t(establishmentDetails.status)}
        </Typography>
      </Box>
      <Box sx={{ width: "auto", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
            >
              <Tab label={t("Details")} value="details" />
              <Tab label={t("manageManagers")} value="users" />
            </TabList>
          </Box>
          <TabPanel value="details">
            <Item key="profile2" sx={{ marginBottom: "10px" }}>
              <Accordion
                sx={{ border: "none", boxShadow: "none", width: "100%" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography fontSize="14px">{t("primaryAddress")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <AddressForm
                    address={address}
                    entity={entity}
                    t={t}
                    editFromEstablishment={true}
                    establishmentEntityId={id}
                    refreshDetails={refreshDetails}
                  />
                </AccordionDetails>
              </Accordion>
            </Item>
            <Item key="profile3">
              <Accordion
                sx={{ border: "none", boxShadow: "none", width: "100%" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography fontSize="14px">{t("contactDetail")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ContactForm
                    contact={contact}
                    t={t}
                    editFromEstablishment={true}
                    loggedInUser={entity}
                    refreshDetails={refreshDetails}
                  />
                </AccordionDetails>
              </Accordion>
            </Item>
            {establishmentDetails &&
              establishmentDetails.status &&
              establishmentDetails.status !== RegistrationStatus.invited && (
                <Typography sx={{ mt: 2, textAlign: "center" }}>
                  <Button
                    variant="contained"
                    onClick={onRejectedHandle}
                    sx={{ borderRadius: "4px" }}
                    disabled={
                      status === RegistrationStatus.inActive ||
                      status === RegistrationStatus.inAtivo
                    }
                  >
                    {establishmentDetails.status === RegistrationStatus.active
                      ? t("deactivate")
                      : t("activate")}
                  </Button>
                </Typography>
              )}
          </TabPanel>
          <TabPanel value="users">
            <ManageManagers t={t} editFromEstablishment={true} estado={establishmentDetails.status}/>
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};

const ManageBranch = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    auth: {
      profile: { entity, status },
      branchEntitiesCount,
      branchEntitiesOffset,
      branchEntitiesLimit,
      branchEntities,
      branchEntitiesPage,
      managerInviteOffset,
      managerInviteLimit,
    },
  } = useSelector((state) => state);

  const {
    adminDashboard: { confirmationDialog, headerTitle, rejectPayload },
  } = useSelector((state) => state);

  const [drawerState, setDrawerState] = React.useState(false);
  const [addressData, setAddressData] = React.useState({});
  const [contactData, setContactData] = React.useState({});
  const [value, setValue] = React.useState("details");
  const [id, setEstablishmentId] = React.useState("");
  const [establishmentEntityId, setEstablishmentEntityId] = React.useState("");
  const [establishmentDetails, setEstablishmentDetails] = React.useState("");
  const totalPageCount = React.useMemo(() => {
    return Math.ceil(branchEntitiesCount / 20);
  }, [branchEntitiesCount]);

  const handleChange = (event, value) => {
    let limit = 20;
    let offset = 0;
    if (value > 1) {
      limit = value * 20;
      offset = limit - 20;
    }
    const data = { limit: limit, offset: offset, entityId: entity?.entityId };
    dispatch(getChildEntitiesList(data));
    dispatch(setBranchEntitiesLimit(limit));
    dispatch(setBranchEntitiesOffset(offset));
    dispatch(setBranchEntitiesPage(value));
  };

  React.useEffect(() => {
    const data = {
      entityId: entity?.entityId,
      offset: branchEntitiesOffset,
      limit: branchEntitiesLimit,
    };
    dispatch(getChildEntitiesList(data));
  }, []);

  const handleClick = React.useCallback(
    (details, address, contact, id, establishmentEntityId) => {
      setContactData(contact);
      setAddressData(address);
      setEstablishmentId(id);
      setEstablishmentEntityId(establishmentEntityId);
      setEstablishmentDetails(details);
      setValue("details");
      setDrawerState(true);
    },
    []
  );

  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationDialog(false));
  }, [dispatch]);

  const onConfirm = () => {
    dispatch(updateRegistrationDetail(rejectPayload))
      .unwrap()
      .then((res) => {
        const data = {
          entityId: entity?.entityId,
          offset: branchEntitiesOffset,
          limit: branchEntitiesLimit,
        };
        dispatch(getChildEntitiesList(data));
        dispatch(setConfirmationDialog(false));
        enqueueSnackbar({
          message: t("successfullyEstablishmentoDeactivated"),
          variant: "success",
        });
        setDrawerState(false);
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid mx={4} item xs={7}>
          <Grid item xs={12}>
            <Stack pb={3} alignItems="end">
              <Button
                startIcon={<AddCircleIcon />}
                variant="contained"
                onClick={() => {
                  navigate("/add-branch");
                }}
                sx={{ borderRadius: "4px" }}
                disabled={
                  status === RegistrationStatus.inActive ||
                  status === RegistrationStatus.inAtivo
                }
              >
                {t("addBranch")}
              </Button>
            </Stack>
          </Grid>
          {branchEntities.length > 0 &&
            branchEntities.map((d) => (
              <React.Fragment key={d.entity.entityId}>
                <Card sx={{ minWidth: { md: 400 }, marginBottom: "16px" }}>
                  <CardContent>
                    <Stack direction={"column"} justifyContent="space-between">
                      {d.addresses
                        .filter(
                          (item) => item.addressId === d.entity.entityAddressId
                        )
                        .map((address, i) => (
                          <>
                            <Box key={i}>
                              <Typography
                                variant="h5"
                                color="text.secondary"
                                gutterBottom
                              >
                                {d.entity.entityName}
                              </Typography>
                              <Box
                                sx={{
                                  width: 1,
                                  backgroundColor:
                                    d.status === RegistrationStatus.active
                                      ? "#e5f1ff"
                                      : "#FFE2E2",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: 1.5,
                                  p: 1.5,
                                  my: 2,
                                }}
                              >
                                <InfoIcon
                                  sx={{
                                    color:
                                      d.status === RegistrationStatus.active
                                        ? "#0167d6"
                                        : "#DC2600",
                                  }}
                                />
                                <Typography
                                  variant="body2"
                                  fontWeight={500}
                                  mx={2}
                                >
                                  {t(d.status)}
                                </Typography>
                              </Box>
                              <Typography
                                pt={0.5}
                                fontWeight="bold"
                                variant="body1"
                              >
                                {address.email}
                              </Typography>
                              <Typography sx={{ mt: 1 }} color="text.secondary">
                                {address.addressLine} {address.locality}{" "}
                              </Typography>
                              <Typography color="text.secondary">
                                {address.subDivision} {address.county}{" "}
                              </Typography>
                              <Typography color="text.secondary">
                                {address.district} {address.postalCode}
                              </Typography>
                              <Typography sx={{ mt: 1 }} color="text.secondary">
                                {address.phone}
                              </Typography>
                            </Box>
                            {d.contact
                              .filter(
                                (item) => item.contactId === d.entity.contactId
                              )
                              .map((contact) => (
                                <>
                                  <Box
                                    minWidth={150}
                                    textAlign="left"
                                    key={contact.id}
                                    pt={1}
                                  >
                                    <Typography
                                      variant="h5"
                                      color="text.secondary"
                                      component="div"
                                    >
                                      {contact.name} ({contact.designation})
                                    </Typography>
                                    <Typography
                                      pt={1.2}
                                      fontWeight="bold"
                                      variant="body1"
                                    >
                                      {contact.email}
                                    </Typography>
                                    <Typography
                                      sx={{ mt: 1 }}
                                      color="text.secondary"
                                    >
                                      {contact.mobile}
                                    </Typography>
                                    <Typography
                                      sx={{ mt: 1 }}
                                      color="text.secondary"
                                    ></Typography>
                                  </Box>
                                  <Typography
                                    sx={{
                                      textAlign: "right",
                                      position: "absolute",
                                      left: "50%",
                                      right: "35%",
                                    }}
                                  >
                                    <Button
                                      sx={{
                                        bgcolor: "#E1EFB0",
                                        width: "36px",
                                        height: "36px",
                                        minWidth: 0,
                                        borderRadius: "4px",
                                      }}
                                      size="small"
                                      onClick={() =>
                                        handleClick(
                                          d,
                                          address,
                                          contact,
                                          d.entity.entityId,
                                          d.entity.id
                                        )
                                      }
                                    >
                                      <SvgIconStyle
                                        src="/static/dashboard/info.svg"
                                        sx={{
                                          color: "black",
                                          width: "16px",
                                          height: "16px",
                                        }}
                                      />
                                    </Button>
                                  </Typography>
                                </>
                              ))}
                          </>
                        ))}
                    </Stack>
                  </CardContent>
                </Card>
              </React.Fragment>
            ))}
          {branchEntities.length === 0 && (
            <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              mt: "5%",
            }}
          >
            <Avatar sx={avataStyles}>
              <SvgIconStyle src="/static/dashboard/icon-estabelecimentos.svg" sx={svgIconStyle} />
            </Avatar>
            <Box sx={{ paddingLeft: "10px" }}>
              <Typography sx={{ marginTop: "10px" }}>
              {t("noBranches")}
              </Typography>
            </Box>
          </Box>
          )}
          {branchEntities.length > 0 && (
            <Stack spacing={2} alignItems={"center"}>
              <Pagination
                count={totalPageCount}
                variant="outlined"
                color="primary"
                onChange={handleChange}
                page={branchEntitiesPage}
              />
            </Stack>
          )}
        </Grid>
        <Grid xs={4}></Grid>
      </Grid>
      <Drawer
        anchor={"right"}
        open={drawerState}
        PaperProps={{
          sx: { width: "50%" },
        }}
        onClose={() => {
          setDrawerState(false);
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
          }}
          onClick={() => setDrawerState(false)}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ProfileAndBanner
          entityLeastDetails={establishmentDetails?.entity}
          address={establishmentDetails?.addresses?.find(
            (address) =>
              address.addressId === establishmentDetails?.entity.entityAddressId
          )}
        />
        <ViewEstablishmentDetails
          id={id}
          establishmentEntityId={establishmentEntityId}
          establishmentDetails={establishmentDetails}
          addressData={addressData}
          contactData={contactData}
          value={value}
          setValue={setValue}
          t={t}
          setDrawerState={() => {
            setDrawerState(false);
          }}
        />
      </Drawer>
      <ConfirmDialog
        open={confirmationDialog}
        handleClose={handleClose}
        title={t("")}
        content={headerTitle}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </>
  );
};

export default ManageBranch;
